import _ from 'lodash';

export default function checkForColumnWidth(localStorageColumns, columns) {
	if (localStorageColumns) {
		_.forEach(localStorageColumns, outerElement => {
			_.forEach(columns, innerElement => {
				if (innerElement.key === outerElement.key) {
					innerElement.width = outerElement.width;
					return;
				}
			});
		});
	}
}
